import { createFileRoute } from "@tanstack/react-router";
import { SymptomAdvisor } from "@/components/SymptomAdvisor";
import { seoHead } from "@/lib/seo";

export const Route = createFileRoute("/symptom-checker")({
  head: () =>
    seoHead({
      path: "/symptom-checker",
      title: "Car Symptom Checker | Which Service Do I Need? | Woodseer Autos",
      description:
        "Describe what your car is doing and get an instant suggestion for the right service, plus a ready-to-send booking enquiry. Poplar, East London E14.",
      breadcrumbs: [
        { name: "Home", path: "/" },
        { name: "Symptom Checker", path: "/symptom-checker" },
      ],
    }),
  component: SymptomCheckerPage,
});

function SymptomCheckerPage() {
  return (
    <section className="py-12 md:py-20">
      <div className="mx-auto max-w-2xl px-4 md:px-6">
        <div className="mb-8 text-center">
          <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">Not sure what your car needs?</h1>
          <p className="mt-2 text-muted-foreground">
            Describe the noise, warning light or problem. We'll suggest the right service and draft your booking enquiry.
          </p>
        </div>
        <SymptomAdvisor />
      </div>
    </section>
  );
}
